export function getDeviceId() {
	const savedUUID = localStorage.getItem("deviceId")
	if (savedUUID) {
		return savedUUID
	}

	const deviceId = crypto.randomUUID()
	localStorage.setItem('devicdId', deviceId)
	return deviceId
}